import React, { Component } from 'react'
import { connect } from 'react-redux'
import Types from 'prop-types'
import { Button } from '@material-ui/core'
import { Description } from '@material-ui/icons'
import { Map } from 'immutable'
import withPromise from 'helpers/withPromise'
import { exportToCsv } from 'reducers/myJobsDataViewer/action'
import Psfs from 'lib/psfs/Psfs'
import { JOBS_DATA_VIEWER_DEFAULT_FIELDS } from 'constants/index'

class ExportButton extends Component {
  state = {
    isDisableExportButton: false,
  }

  setDisableExportButton = isDisableExportButton =>
    this.setState({ isDisableExportButton })

  onExportBtnClick = () => {
    this.setDisableExportButton(true)
    const {
      site,
      activeDateRange,
      jobs,
      jobTasks,
      jobInputs,
      jobInputTypes,
      locusGroups,
      locuses,
      dataFields,
      // sorting,
      // TODO: если нужна будет сортировка при импорте, то нужно сортировку
      // таблицы подружить с пользовательскими фильтрами и тогда здесь допилить это добавление
      exportToCsv,
    } = this.props

    const arrDataFields = dataFields.toArray()
    const params = {
      psfs: new Psfs(),
      params: {
        site,
        from: activeDateRange.get('start').format('YYYY-MM-DD'),
        to: activeDateRange.get('end').format('YYYY-MM-DD'),
        fields: arrDataFields.length
          ? arrDataFields
          : JOBS_DATA_VIEWER_DEFAULT_FIELDS,
      },
    }

    // params.psfs.addSort(Object.keys(sorting)[0], Object.values(sorting)[0])
    // TODO доработать когда выше будет также доработано

    const filters = {
      job: jobs.toArray(),
      job_task: jobTasks.toArray(),
      job_input: jobInputs.toArray(),
      job_input_type: jobInputTypes.toArray(),
      locus_group: locusGroups.toArray(),
      locus: locuses.toArray(),
    }

    Object.keys(filters).forEach(key => {
      if (filters[key].length) {
        params.psfs.addFilter(key, filters[key], 'in')
      }
    })

    withPromise(exportToCsv, params).then(() =>
      this.setDisableExportButton(false),
    )
  }

  render() {
    const { isDisableExportButton } = this.state

    return (
      <Button
        disabled={isDisableExportButton}
        onClick={this.onExportBtnClick}
        variant="contained"
        color="primary"
        classes={{
          root: 'export-button',
        }}>
        <Description />
      </Button>
    )
  }
}

ExportButton.propTypes = {
  activeDateRange: Types.instanceOf(Map),
}

export default connect(
  store => ({
    activeDateRange: store.getIn(['myJobsDataViewer', 'activeDateRange']),
    site: store.getIn(['profile', 'jobsDataViewerFilters', 'site']),
    locusGroups: store.getIn([
      'profile',
      'jobsDataViewerFilters',
      'locusGroups',
    ]),
    locuses: store.getIn(['profile', 'jobsDataViewerFilters', 'locuses']),
    dataFields: store.getIn(['profile', 'jobsDataViewerFilters', 'dataFields']),
    jobs: store.getIn(['profile', 'jobsDataViewerFilters', 'jobs']),
    jobTasks: store.getIn(['profile', 'jobsDataViewerFilters', 'jobTasks']),
    jobInputs: store.getIn(['profile', 'jobsDataViewerFilters', 'jobInputs']),
    jobInputTypes: store.getIn([
      'profile',
      'jobsDataViewerFilters',
      'jobInputTypes',
    ]),
    sorting: store.getIn(['profile', 'jobsDataViewerFilters', 'sorting']),
  }),
  {
    exportToCsv,
  },
)(ExportButton)
